import { Component, OnInit } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {QuestionsModel} from '../../shared/questions.model';
import {ActivatedRoute, Params} from '@angular/router';
import {Subscription} from 'rxjs/Subscription';
import {PagerServiceService} from '../../shared/services/pager-service/pager-service.service';


@Component({
  selector: 'app-load-quiz',
  templateUrl: './load-quiz.component.html',
  styleUrls: ['./load-quiz.component.css']
})
export class LoadQuizComponent implements OnInit {
  private route$: Subscription;
  subjectId: number;
  questionsList: any;
  quizOptions: any;
  finalOptions: any;
  lastIP: any;
  questions: any;
  loading: boolean;
  private allItems: any;
  pager: any = {};
  pagedItems: any[];
  page: number;
  offset: number;
  totalItems: number;
  constructor(private httpClient: HttpClient, private route: ActivatedRoute, private pagerService: PagerServiceService) { }

  ngOnInit()  {
    this.route$ = this.route.params.subscribe(
      (params: Params) => {
        this.subjectId = params['id'];
      });
    this.totalItems = 0;
    this.questionsList = [];
    this.quizOptions = [];
    this.finalOptions = [];
    this.lastIP = [];
    this.questions = [];
    this.loading = true;
    this.offset = 0;
    this.page = 1;
    this.getQuiz(12, this.offset);
  }
getQuiz(limit, offset) {
  this.httpClient.get('http://ec2-18-223-41-152.us-east-2.compute.amazonaws.com:8080/v1/quiz/list/options/subject/'
    + this.subjectId + '/limit/' + limit + '/offset/' + offset)
    .subscribe((data: QuestionsModel) => {
     // console.log('data', data);
      this.totalItems = data.data.totalNumberOfItems;
      this.setPage(12, this.offset, this.page);
    });
}
  setPage( limit, offset, page) {
    this.httpClient.get('http://ec2-18-223-41-152.us-east-2.compute.amazonaws.com:8080/v1/quiz/list/options/subject/'
      + this.subjectId + '/limit/' + limit + '/offset/' + offset)
      .subscribe((data: QuestionsModel) => {
         // console.log('data', data);
        this.totalItems = data.data.totalNumberOfItems;
        this.allItems = data.data.items;
        // this.offset = offset + limit;
         // console.log('offset', this.offset);
        this.questionsList = this.allItems;
        this.page = page ;

         // console.log('Array20', this.totalItems);
         // console.log('Array20', this.page);
        this.pager = this.pagerService.getPager(this.totalItems, this.page, 12);
         // console.log('questionsList', this.questionsList);

        this.pagedItems = this.questionsList;
         // console.log('pagedItems', this.pagedItems);

        this.loading = false;
        for (let i = 0; i < this.questionsList.length; i++) {
          this.quizOptions.push(this.questionsList[i].quizOptions);
        }
      });


  }
  prevPage( limit, offset, page) {
    this.loading = true;
     console.log('offsetB4', offset);
    offset = offset - limit ;
     console.log('offsetFter', offset);
    this.offset = offset;
    this.httpClient.get('http://ec2-18-223-41-152.us-east-2.compute.amazonaws.com:8080/v1/quiz/list/options/subject/'
      + this.subjectId + '/limit/' + limit + '/offset/' + offset)
      .subscribe((data: QuestionsModel) => {
         // console.log('data', data);
        this.totalItems = data.data.totalNumberOfItems;
        this.allItems = data.data.items;
        this.questionsList = this.allItems;
        this.page = page ;

         // console.log('Array20', this.totalItems);
         // console.log('Array20', this.page);
        this.pager = this.pagerService.getPager(this.totalItems, this.page, 12);
         // console.log('questionsList', this.questionsList);

        this.pagedItems = this.questionsList;
         // console.log('pagedItems', this.pagedItems);

        this.loading = false;
        for (let i = 0; i < this.questionsList.length; i++) {
          this.quizOptions.push(this.questionsList[i].quizOptions);
        }
      });


  }
  nxtPage( limit, offset, page) {
    this.loading = true;
     console.log('offsetB4', offset);
    offset = offset + limit;
    this.offset = offset;
     console.log('offsetFter', offset);
    this.httpClient.get('http://ec2-18-223-41-152.us-east-2.compute.amazonaws.com:8080/v1/quiz/list/options/subject/'
      + this.subjectId + '/limit/' + limit + '/offset/' + offset)
      .subscribe((data: QuestionsModel) => {
         // console.log('data', data);
        this.totalItems = data.data.totalNumberOfItems;
        this.allItems = data.data.items;
        this.questionsList = this.allItems;
        this.page = page ;

         // console.log('Array20', this.totalItems);
         // console.log('Array20', this.page);
        this.pager = this.pagerService.getPager(this.totalItems, this.page, 12);
         // console.log('questionsList', this.questionsList);

        this.pagedItems = this.questionsList;
         // console.log('pagedItems', this.pagedItems);

        this.loading = false;
        for (let i = 0; i < this.questionsList.length; i++) {
          this.quizOptions.push(this.questionsList[i].quizOptions);
        }
      });


  }
  getPage( limit, offset, page) {
     console.log('CurrentP' , this.pager.currentPage, page );
    this.loading = true;
     console.log('offsetB4', offset);
    offset = (page - 1) * limit;
    this.offset = offset;
     console.log('offsetFter', offset);
    this.httpClient.get('http://ec2-18-223-41-152.us-east-2.compute.amazonaws.com:8080/v1/quiz/list/options/subject/'
      + this.subjectId + '/limit/' + limit + '/offset/' + offset)
      .subscribe((data: QuestionsModel) => {
         // console.log('data', data);
        this.totalItems = data.data.totalNumberOfItems;
        this.allItems = data.data.items;
        this.questionsList = this.allItems;
        this.page = page ;

         // console.log('Array20', this.totalItems);
         // console.log('Array20', this.page);
        this.pager = this.pagerService.getPager(this.totalItems, this.page, 12);
         // console.log('questionsList', this.questionsList);

        this.pagedItems = this.questionsList;
         // console.log('pagedItems', this.pagedItems);

        this.loading = false;
        for (let i = 0; i < this.questionsList.length; i++) {
          this.quizOptions.push(this.questionsList[i].quizOptions);
        }
      });


  }



  goBack() {
    this.loading = true;
    window.history.go(-1);
  }
}



// WEBPACK FOOTER //
// ./src/app/load-quiz/load-quiz.component.ts